// В.2.d-2 / В.2.cards-2A: Опытный хирург (liv_opytnyy_hirurg, rare, 2/1/3).
// Приказ при выставлении: «Воскрешает выбранного юнита из своей стопки сброса
// с 50% max HP (округление вверх)».
// В.2.cards-2A: статы понижены 3/1/4 → 2/1/3 (через xlsx). 50%-воскрешение
// уже было реализовано в resurrectUnit — изменений в коде Хирурга не нужно.
//
// Picker:
//   - Кандидаты: только живые карты сброса игрока с type === 'unit'.
//     Действия и Моды исключены.
//   - Если в сбросе нет ни одного юнита → Приказ сгорает (overlay не
//     открывается).
//   - Если на поле своей стороны нет свободного слота → Приказ сгорает
//     (некуда воскрешать).
//   - В противном случае открывается overlay (prompt 'hirurg-discard'),
//     игрок выбирает юнита.
//
// Эффект: resurrectUnit(state, deadCard, side='player', slot=null) —
// случайный свободный слот, current_hp = ceil(base.hp/2), полная броня,
// без Initiation Cooldown, все Моды/баффы/keywords сохранены.
//
// Бот: автовыбор случайной карты из сброса.

import { resurrectUnit } from './resurrect.js';
import { registerImplementedAbility } from './warn-unimplemented.js';

export const CARD_ID = 'liv_opytnyy_hirurg';
const LABEL = 'Опытный хирург';

registerImplementedAbility(CARD_ID, 'order');

// Кандидаты — все живые карты-юниты в сбросе (тестируется в picker'е).
export function hirurgDiscardCandidates(state, ownerIdx) {
  const me = state.players?.[ownerIdx];
  if (!me) return [];
  return me.discard.filter(c => c?.type === 'unit');
}

// Найти юнита в сбросе по instanceId.
function findInDiscardByInstanceId(state, ownerIdx, instanceId) {
  if (instanceId == null) return null;
  const me = state.players?.[ownerIdx];
  if (!me) return null;
  return me.discard.find(c => c.instanceId === instanceId && c.type === 'unit') || null;
}

export function opytnyyHirurgOrder(state, ownerIdx, hirurg, opts = {}) {
  if (!hirurg || !hirurg.isAlive()) return;
  if (hirurg.current?.silenced) return;
  const me = state.players?.[ownerIdx];
  if (!me) return;
  const candidates = hirurgDiscardCandidates(state, ownerIdx);
  if (candidates.length === 0) {
    state.log?.add(`🩺 ${LABEL}: в сбросе нет юнитов — Приказ сгорает`);
    return;
  }
  if (!me.hasFreeSlot()) {
    state.log?.add(`🩺 ${LABEL}: нет свободных ячеек — Приказ сгорает`);
    return;
  }

  // Цель из opts (UI) или авто-выбор (бот).
  let dead = null;
  const optsHasKey = Object.prototype.hasOwnProperty.call(opts, 'resurrectInstanceId');
  if (opts.resurrectInstanceId != null) {
    dead = findInDiscardByInstanceId(state, ownerIdx, opts.resurrectInstanceId);
    if (!dead) {
      state.log?.add(`🩺 ${LABEL}: выбранная цель недоступна — Приказ сгорает`);
      return;
    }
  } else if (optsHasKey) {
    // Игрок явно нажал «Пропустить».
    state.log?.add(`🩺 ${LABEL}: цель не выбрана — Приказ сгорает`);
    return;
  } else {
    // Бот: автовыбор случайного юнита из сброса.
    dead = candidates[state.rng.int(candidates.length)];
  }
  const ok = resurrectUnit(state, dead, 'player', null);
  if (!ok) {
    state.log?.add(`🩺 ${LABEL}: воскрешение не состоялось`);
    return;
  }
  state.log?.add(`🩺 ${LABEL} [${me.name}]: воскрешён ${dead.name_ru}`);
}
